module.exports = {
    Integrations: "API",
    AbandonedProcess: "Flow",
    Login: "Login",
    BatchJobs: "ApexJob"
};